import { createContext, useContext } from "react";

export const TransitionContext = createContext(null);

export function useTransition() {
  return useContext(TransitionContext);
}
